import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { store } from '@core/Store'
import { postShareToBetLoop, postSportsShareToBetLoop } from '@core/Areas/BetLoop/helpers/api'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'

export const postSharedBetToBetLoop = async ({
  ticketSequence = undefined,
  coupon = undefined,
}: PostSharedBetArgs): Promise<{
  postId: number
  betsShared?: number
}> => {
  if (ticketSequence) {
    return postShareToBetLoop({ ticketSequence })
  }

  if (coupon) {
    if (!coupon) {
      throw new Error('Kambi: Unable to get Kambi coupon for share')
    }
    const kambiBearer = selectPlayerSessionId(store.getState())
    if (!kambiBearer) {
      throw new Error('Kambi: Not authorised to share to bet loop')
    }

    const bets = coupon.bets.map(({ betRef }) => ({
      couponRef: coupon.couponRef,
      betRef,
      kambiBearer,
    }))
    const responses = await Promise.allSettled(bets.map(postSportsShareToBetLoop))

    if (responses.every(response => response.status === 'rejected')) {
      throw new Error('Unable to share bets to Bet Loop')
    }
    const successfulShares = responses.filter(response => response.status === 'fulfilled')
    const successfulSharesCount = successfulShares.length

    return {
      postId: successfulShares[0].value.postId,
      betsShared: successfulSharesCount,
    }
  }

  throw new Error('No bet ID provided for share')
}

// =====
// Types
// =====

type PostSharedBetArgs =
  | { ticketSequence: number; coupon?: undefined }
  | {
      coupon: KambiHistoryCoupon
      ticketSequence?: undefined
    }
